// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-259zm";
var _3 = "header-35WkM";
var _4 = "icon-Tfdp2";
export { _1 as "__esModule", _2 as "wrapper", _3 as "header", _4 as "icon" }
export default { "__esModule": _1, "wrapper": _2, "header": _3, "icon": _4 }
